export default __webpack_public_path__ + "static/media/video-play-button.6c0923b0.svg";